import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as AtSignIcon } from './atSign.svg';

export const AtSign = IconHOC(AtSignIcon);
